import "core-js/modules/es.regexp.exec.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Grid, makeStyles } from '@applyboard/ui-components';
import Score from "../Score";
import Section from "./Section";
var useStyles = makeStyles({
  grid: {
    paddingBottom: '22px'
  }
});
var TestScores = function TestScores(props) {
  var test = props.test,
    value = props.value,
    _onChange = props.onChange,
    error = props.error,
    showError = props.showError;
  var v = value.v,
    vp = value.vp,
    q = value.q,
    qp = value.qp,
    w = value.w,
    wp = value.wp;
  var classes = useStyles();
  var itemSpacing = 2;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    className: classes.grid
  }, test === 'GMAT' && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Section, null, "Total")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: itemSpacing
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Score",
    name: "t",
    section: "Total",
    value: value.t,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.t,
    showError: showError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Rank",
    name: "tp",
    section: "Total",
    value: value.tp,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.tp,
    showError: showError
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Section, null, "Verbal")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: itemSpacing
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Score",
    name: "v",
    section: "Verbal",
    value: v,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.v,
    showError: showError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Rank",
    name: "vp",
    section: "Verbal",
    value: vp,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.vp,
    showError: showError
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Section, null, "Quantitative")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: itemSpacing
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Score",
    name: "q",
    section: "Quantitative",
    value: q,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.q,
    showError: showError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Rank",
    name: "qp",
    section: "Quantitative",
    value: qp,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.qp,
    showError: showError
  })))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Section, null, "AWA")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    spacing: itemSpacing
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Score",
    name: "w",
    section: "AWA",
    value: w,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.w,
    showError: showError
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Score, {
    exam: test,
    label: "Rank",
    name: "wp",
    section: "AWA",
    value: wp,
    onChange: function onChange(e) {
      return _onChange(e, test);
    },
    error: error.wp,
    showError: showError
  })))));
};
export default TestScores;